/* eslint-disable no-param-reassign */

import { TOUJOU_EVENT_MAIN_NAV_SECOND_LEVEL_OPEN } from '../utils/constants';

function setSecondLevelPosition(list) {
  const windowWidth = window.innerWidth;
  const windowPaddingX = parseInt(window.getComputedStyle(document.querySelector('html')).getPropertyValue('font-size'), 10);
  const listWidth = list.scrollWidth;
  const listPositionX = parseInt(list.getBoundingClientRect().x, 10);

  if ((listWidth + listPositionX) < windowWidth) return;

  let listOffsetOriginal = 0;

  if (list.getAttribute('data-offset-x-original')) {
    listOffsetOriginal = parseInt(list.getAttribute('data-offset-x-original'), 10);
    if (typeof (listOffsetOriginal) !== 'number' || Number.isNaN(listOffsetOriginal)) listOffsetOriginal = 0;
  }

  const translateX = listOffsetOriginal - (listPositionX + listWidth - windowWidth + 2 * windowPaddingX);

  if (translateX === 0) {
    list.style.setProperty('--nav-list-offset-x', null);
    return;
  }

  list.style.setProperty('--nav-list-offset-x', `${translateX}px`);
}

export function initMainNavPosition() {
  const mainNavEl = document.querySelector('.wrap--navigation');
  if (!mainNavEl) return;

  const secondLevelLists = mainNavEl.querySelectorAll('.navigation--second-level');
  if (!secondLevelLists.length) return;

  secondLevelLists.forEach((list) => {
    const listOffsetOriginal = getComputedStyle(list).getPropertyValue('--nav-list-offset-x');

    if (listOffsetOriginal) {
      list.setAttribute('data-offset-x-original', listOffsetOriginal);
    }
  });

  window.addEventListener(TOUJOU_EVENT_MAIN_NAV_SECOND_LEVEL_OPEN, (event) => {
    const list = event.detail.targetList;
    if (!list) return;

    const listOffsetOriginal = list.getAttribute('data-offset-x-original') || null;
    list.style.setProperty('--nav-list-offset-x', listOffsetOriginal);

    setTimeout(() => setSecondLevelPosition(list), 1);
  });
}
